import { all } from 'redux-saga/effects';
import payrollPlus from './payroll-plus-new-saga';

export default function* rootSaga(action) {
	yield all([payrollPlus(action)]);
}
